"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var react_select_async_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/react_select_async_input"));
var react_select_1 = require("react-select");
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var keyboard_shown_1 = require("@hikakaku/shared/util/keyboard_shown");
var scroller_1 = __importDefault(require("@hikakaku/shared/jquery-modules/scroller"));
var util_1 = __importDefault(require("@hikakaku/shared/util/util"));
var react_2 = require("react");
var LOAD_DELAY = 400;
var SCROLL_MARGIN_TOP = 0;
var MenuStatus;
(function (MenuStatus) {
    MenuStatus["CLOSE"] = "menu-close";
    MenuStatus["OPEN"] = "menu-open";
})(MenuStatus || (MenuStatus = {}));
var ReactSelectAsyncInputStore = /** @class */ (function (_super) {
    __extends(ReactSelectAsyncInputStore, _super);
    function ReactSelectAsyncInputStore(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.component = react_select_async_input_1.default;
        _this.selectWrapperRef = react_1.default.createRef();
        _this.menuStatus = MenuStatus.CLOSE;
        _this.cache = {};
        _this.handleChange = function (options) {
            var option = Array.isArray(options) ? options[0] : options;
            _this.value = option ? option.value : undefined;
        };
        _this.handleInputChange = function (value, _a) {
            var action = _a.action;
            // strictSelection の場合、入力途中の文字列は値として確定させない（DBの値を選択した時のみ確定）
            if (action === 'input-change' && !_this.strictSelection) {
                _this.value = value;
            }
        };
        _this.loadOptions = function (inputValue, callback) {
            if (!inputValue) {
                callback([]);
                return;
            }
            if (inputValue in _this.cache) {
                callback(_this.cache[inputValue]);
                return;
            }
            var loadKey = {}; // ユニークキー
            _this.latestLoadKey = loadKey;
            _this.doFetchOptions(inputValue, loadKey, callback);
        };
        _this.handleMenuOpen = function () {
            _this.menuStatus = MenuStatus.OPEN;
        };
        _this.handleMenuClose = function () {
            _this.menuStatus = MenuStatus.CLOSE;
        };
        _this.handleFocus = function () {
            (0, keyboard_shown_1.keyboardShown)().then(_this.scrollInputTop).catch(console.error);
        };
        _this.filterOption = function (option, rawInput) {
            return Boolean(rawInput);
        };
        _this.fetchOptions = function (searchWords, callback) {
            var params = (0, convert_case_keys_1.toSnakeKeys)(__assign({ searchWords: searchWords }, _this.query));
            axios_1.default
                .get(_this.apiUrl, { params: params })
                .then(function (_a) {
                var data = _a.data;
                var apiOptions = data.map(function (item) { return ({ value: item.name, label: item.name }); });
                // strictSelection の場合、ユーザーの入力文字列を候補に含めない
                var options = _this.strictSelection
                    ? apiOptions
                    : __spreadArray([{ value: searchWords, label: searchWords }], apiOptions, true);
                _this.cache[searchWords] = options;
                callback(options);
            })
                .catch(function () {
                var fallback = _this.findOptionForShorterKeywordFromCache(searchWords);
                callback(_this.strictSelection
                    ? fallback
                    : __spreadArray([{ value: searchWords, label: searchWords }], fallback, true));
            });
        };
        _this.findOptionForShorterKeywordFromCache = function (keyword) {
            if (keyword.length === 0) {
                return [];
            }
            return keyword in _this.cache
                ? _this.cache[keyword].slice()
                : _this.findOptionForShorterKeywordFromCache(keyword.slice(0, keyword.length - 1));
        };
        _this.scrollInputTop = function () {
            if (!util_1.default.isMobile()) {
                return;
            }
            scroller_1.default.scrollTo(_this.selectWrapperRef.current, { marginTop: SCROLL_MARGIN_TOP });
        };
        _this.apiUrl = props.optionDataSource.url;
        _this.query = props.optionDataSource.query;
        _this.strictSelection = (_a = props.strictSelection) !== null && _a !== void 0 ? _a : false;
        _this.doFetchOptions = (0, lodash_1.debounce)(function (inputValue, loadKey, callback) {
            if (_this.isRunning(loadKey)) {
                return;
            }
            _this.fetchOptions(inputValue, callback);
        }, LOAD_DELAY);
        return _this;
    }
    Object.defineProperty(ReactSelectAsyncInputStore.prototype, "selectedOption", {
        get: function () {
            return this.value ? { label: this.value, value: this.value } : undefined;
        },
        enumerable: false,
        configurable: true
    });
    ReactSelectAsyncInputStore.prototype.isRunning = function (loadKey) {
        return loadKey === this.latestLoadKey;
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof react_2.RefObject !== "undefined" && react_2.RefObject) === "function" ? _a : Object)
    ], ReactSelectAsyncInputStore.prototype, "selectWrapperRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ReactSelectAsyncInputStore.prototype, "menuStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof LoadKey !== "undefined" && LoadKey) === "function" ? _b : Object)
    ], ReactSelectAsyncInputStore.prototype, "latestLoadKey", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "cache", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof react_select_1.ValueType !== "undefined" && react_select_1.ValueType) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], ReactSelectAsyncInputStore.prototype, "selectedOption", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "handleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "handleInputChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "loadOptions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "handleMenuOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "handleMenuClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReactSelectAsyncInputStore.prototype, "handleFocus", void 0);
    return ReactSelectAsyncInputStore;
}(abstract_input_store_1.default));
exports.default = ReactSelectAsyncInputStore;
